import styled, { css } from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';

export const Summary = styled.div`
  background: #fafafa;
  border-radius: 4px;
  height: 60px;
  padding: auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  & > span:not(:last-child) {
    margin-right: 10px;
  }

  ${({ theme }) => theme.media.mobile} {
    & > span:not(:last-child) {
      ${getFontStyle('bold120_B3')}
    }

    & > span:last-child {
      ${getFontStyle('bold120_T1')}
    }
  }
`;

export const Record = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 200px;
  align-items: center;

  & > div {
    width: 160px; // 애니메이션 작업하면서 수정
    height: 100px;
    margin-bottom: 10px;
  }

  ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    flex-direction: row;
    justify-content: center;

    & > div {
      width: 112px; // 애니메이션 작업하면서 수정
      height: 70px;
      margin-bottom: 10px;
    }
  }
`;

export const EmphasizeAnimation = styled.div`
  display: flex;
  justify-content: center;

  .emphasize {
    color: #d63461;
  }

  & > ${Record}:not(:last-child) {
    margin-right: 100px;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    ${getFontStyle('bold120_B3')}

    & > ${Record}:not(:last-child) {
      margin: 0;
    }
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 20px;
  text-align: left;

  & > span:not(:last-child) {
    margin-bottom: 7px;
  }

  & > span:last-child {
    text-align: right;
    color: #7d7d7d;
    margin-top: auto;
  }

  ${({ theme }) => theme.media.mobile} {
    min-width: 250px;
  }
`;

export const InfoBlockWrapper = styled.div`
  display: flex;
  overscroll-behavior: contain;
  mouse-wheel: horizontal;
  padding: 0 30px;

  ${({ theme }) => theme.media.mobile} {
    padding: 0 20px;
  }

  & > ${InfoBlock}:not(:last-child) {
    margin-right: 15px;
  }

  ${({ theme }) => theme.media.mobile} {
    overflow-x: scroll;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CardContentWrapper = styled.div`
  padding: 0 30px;

  ${({ theme }) => theme.media.mobile} {
    padding: 0 20px;
  }
`;

export const Wrapper = styled.div`
  padding: 30px 0 0 0;

  & > div > ${EmphasizeAnimation} {
    margin-top: 45px;
  }

  & > ${InfoBlockWrapper} {
    margin-top: 56px;
  }

  ${({ theme }) => theme.media.mobile} {
    & > div > ${EmphasizeAnimation} {
      margin-top: 28px;
    }

    & > ${InfoBlockWrapper} {
      margin-top: 28px;
    }
  }
`;

export const SubText = styled(Text)`
  color: ${({ theme }) => theme.colors.gray700};

  &::before {
    content: '-';
    margin-right: 10px;
  }
`;

export const CompanySummaryWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 8px;
  width: 731px;

  ${({ theme }) => theme.media.tablet} {
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    width: 100%;
    gap: 0px;
  }
`;
export const CompanySummaryItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const S = {
  SummaryCardItem: styled.div`
    width: 256px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;

    ${({ theme }) => theme.media.mobile} {
      width: unset;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }
  `,
  Label: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
    }
    ${({ theme }) => theme.media.mobile} {
      flex-direction: row;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  `,
  TitleWrapper: styled.div<{ isEmpty?: boolean }>`
    display: flex;
    align-items: center;

    ${(props) =>
      props.isEmpty &&
      css`
        color: ${({ theme }) => theme.colors.gray600};
      `}
    ${({ theme }) => theme.media.mobile} {
      span {
        order: 2;
      }

      div {
        order: 1;
      }
    }
  `,
  Title: styled(Text)`
    color: ${({ theme }) => theme.colors.gray700};
    margin-bottom: 3px;
    margin-top: 16px;

    ${({ theme }) => theme.media.mobile} {
      margin: 0;

      ${getFontStyle('midium150_B3')}
    }
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${({ theme }) => theme.media.mobile} {
      align-items: flex-end;
      gap: 8px;
    }
  `,
  Badge: styled.div`
    background-color: ${({ theme }) => theme.colors.magenta100};
    color: ${({ theme }) => theme.colors.magenta700};
    border-radius: 4px;
    padding: 0 4px;
    margin-left: 4px;
    ${getFontStyle('bold150_C1')};

    ${({ theme }) => theme.media.mobile} {
      margin: 0;
      margin-right: 4px;

      ${getFontStyle('bold150_B3')};
    }
  `,
  SubTitleWrapper: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 35px;
    margin: 16px 0;

    ${({ theme }) => theme.media.mobile} {
      height: 100%;
      margin: 0;
    }
  `,
  SubTitle: styled.div<{ isEmpty?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.greynavy300};

    &:nth-child(2) {
      margin-top: 4px;
    }

    span {
      ${(props) =>
        props.isEmpty &&
        css`
          &:nth-child(2) {
            color: ${({ theme }) => theme.colors.greynavy100};
            ${getFontStyle('midium120_C1')}
          }
        `}

      &:nth-child(1) {
        margin-right: 4px;
      }

      &:nth-child(3) {
        margin-left: 4px;
      }
    }

    ${({ theme }) => theme.media.mobile} {
      justify-content: flex-end;
      &:nth-child(2) {
        margin-top: 8px;
      }
      span {
        font-size: 14px;
        line-height: 17px;
      }
    }
  `,
  Source: styled(Text)`
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.gray700};

    div {
      margin-left: 5px;
    }
    ${({ theme }) => theme.media.mobile} {
      ${getFontStyle('midium150_B3')}
    }
  `,
};
